export var LanguageCodeEnum;
(function (LanguageCodeEnum) {
    LanguageCodeEnum[LanguageCodeEnum["NL"] = 0] = "NL";
    LanguageCodeEnum[LanguageCodeEnum["EN"] = 1] = "EN";
})(LanguageCodeEnum || (LanguageCodeEnum = {}));
export const LanguageStatusMap = new Map([
    [LanguageCodeEnum.NL, 'Dutch'],
    [LanguageCodeEnum.EN, 'English']
]);
export var LanguageShortEnum;
(function (LanguageShortEnum) {
    LanguageShortEnum["Dutch"] = "nl";
    LanguageShortEnum["English"] = "en";
})(LanguageShortEnum || (LanguageShortEnum = {}));
